module.exports = __webpack_public_path__ + "static/media/arrow-both.0bfe2193.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-both.svg
// module id = 532
// module chunks = 0